import React, { Component } from 'react';
import * as MaterialStorageLocAction from '../actions/MaterialStorageLocAction';
import MaterialStorageLocStore from '../stores/MaterialStorageLocStore';
import * as $ from 'jquery';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import Select from 'react-select';
import { withTranslation, Trans } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import * as MenuAction from '../actions/MenuAction';
import swal from 'sweetalert';
let currentPagePath;
//CPW-275[ WW_1040_PC_03 Spaces can be inserted in Material Storage Location] -Nandhini L
let existIndex = -1;

class MaterialStorageLocComponent extends Component {
    constructor(props) {
        super(props);
        //CPW-275[ WW_1040_PC_03 Spaces can be inserted in Material Storage Location] -Nandhini L
        this.onEditClick = this.onEditClick.bind(this);

        this.state = {
            BusUnitDD: [],
            BuOptions: [],
            BuDDName: "",
            BuDDValue: "",
            SelectedArea: {},
            Area: [],
            MatGridArray: [],
            IsNewLoc: false,
            NewLocAis: "",
            NewLocRow: "",
            NewLocShf: "",
            NewLocBin: "",
            AddOrUpdateLocRes: "",
            DELETE_STORLOC_FLGChk: false,
            EditIndex: "",
            pageCount: "",
            pageNo: "1",
            IsSearchResult: false,
            isFavorited: false,
            islocationCheck: false,
            iseditClick: false
        }
    }
    /***
     * MSL_PC_07 - Deepthi N H
     * */
    componentDidMount() {
        
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        currentPagePath = this.props.location.pathname;
        currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
        let getFavPageBO = {
            Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
            pageURL: currentPagePath.toLowerCase(),
            Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
        };
        MaterialStorageLocAction.getCurrentFavPage(getFavPageBO);
        this.PageLoad();
        MaterialStorageLocStore.on('PageLoad', this.PageLoadResponse);
        MaterialStorageLocStore.on('LoadArea', this.GetAreaDataResponse);
        MaterialStorageLocStore.on('SearchItem', this.SearchBtnClickResponse);
        MaterialStorageLocStore.on('AddOrUpdateLoc', this.EditClickResponse);
        MaterialStorageLocStore.on('favpage', this.loadFavPageResponse.bind(this));
        MaterialStorageLocStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
    }
    /***
     * MSL_PC_07 - Deepthi N H
     * */
    componentWillUnmount() {
        ////WW-401 Weekly Regression Testing from A1QA - Part II - Deepthi
        //MaterialStorageLocStore.removeListener('PageLoad', this.SearchItemClickResponse); 
        MaterialStorageLocStore.removeListener('LoadArea', this.GetAreaDataResponse);
        MaterialStorageLocStore.removeListener('SearchItem', this.SearchBtnClickResponse);
        MaterialStorageLocStore.removeListener('AddOrUpdateLoc', this.EditClickResponse);
        MaterialStorageLocStore.removeListener('updateFavPage', this.updateFavPageResponse.bind(this));
    }
    /***
     * MSL_PC_09 - Deepthi N H
     * */
    PageLoad = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let PageLoadBO = {
            Session_UserID: CookieService.getLocalStorageValues("Session_UserID")
        }
        MaterialStorageLocAction.PageLoad(PageLoadBO);
    }
    /***
     * MSL_PC_17 - Deepthi N H
     * */
    PageLoadResponse = () => {
        
        let PageLoadData = JSON.parse(MaterialStorageLocStore.PageLoadData);
        let BusUnitDD = PageLoadData;
        this.BindBUDD(BusUnitDD);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    /***
     * MSL_PC_18 - Deepthi N H
     * */
    BindBUDD = (BusUnitDD) => {
        
        let BusUnitDDvalue = []
        if (BusUnitDD.length > 0) {
            BusUnitDD.map((val, index) => {
                let localArray = {
                    value: val.BUSINESS_UNIT,
                    label: val.DESCR,
                }
                BusUnitDDvalue.push(localArray)

            });
        }
        this.setState({ BuOptions: BusUnitDDvalue });

    };
    /***
     * MSL_PC_19 - Deepthi N H
     * */
    OnChangeBU = (e) => {
        
        let Areadd = [];
        let a = e.value;
        this.setState(
            { BuDDName: e.label, BuDDValue: e.value, SelectedArea: {}, MatGridArray: [], IsSearchResult: false });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let AreaDataBO = {
            SelectedBU: e.value
        };
        MaterialStorageLocAction.LoadArea(AreaDataBO);

    }
    /***
     * MSL_PC_25 - Deepthi N H
     * */
    GetAreaDataResponse = () => {
        
        let AreaData = JSON.parse(MaterialStorageLocStore.LoadAreaData);
        let AreaDD = AreaData;
        this.BindAreaDD(AreaDD);
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    /***
     * MSL_PC_26 - Deepthi N H
     * */
    BindAreaDD = (AreaDD) => {
        
        let AreaDDvalue = []
        if (AreaDD.length > 0) {
            AreaDD.map((val, index) => {
                let localArray = {
                    value: val.AREA,
                    label: val.AREA,
                }
                AreaDDvalue.push(localArray)

            });
        }
        this.setState({ Area: AreaDDvalue });
    };
    /***
     * MSL_PC_27 - Deepthi N H
     * */
    OnChangeArea = (e) => {
        
        let area = e;
        this.setState({ SelectedArea: area, IsSearchResult: false });

    }
    /***
     * MSL_PC_28 - Deepthi N H
     * */
    SearchBtnClick = () => {
        
        if ((this.state.SelectedArea == {} || Object.keys(this.state.SelectedArea).length == 0) && this.state.BuDDValue == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please select crib ID and Area"
            });
            // alert("Please Select Crib Id and Area");
        }
        else if (Object.keys(this.state.SelectedArea).length == 0) {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please Select Area"
            });
            // alert("Please Select Area");
        }
        else if (this.state.BuDDValue == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please Select Crib Id"
            });
            // alert("Please Select Crib Id");
        }
        else {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            let SearchBO = {
                SelectedBU: this.state.BuDDValue,
                SelectedArea: this.state.SelectedArea.value
            }
            MaterialStorageLocAction.SearchItem(SearchBO);
        }
        //[9/20/22, Bug - 2677 - To close inline new location, Dhevanesm R]
        this.setState({ IsNewLoc: false });
    }
    /***
     * MSL_PC_32 - Deepthi N H
     * */
    SearchBtnClickResponse = () => {
        
        let SearchData = JSON.parse(MaterialStorageLocStore.SearchItemData);
        let LocGridData = SearchData;
        LocGridData.forEach((value, index) => {
            value.IsEditClicked = false;
            value.EditExisAis = value.STOR_LEVEL_1;
            value.EditExisRow = value.STOR_LEVEL_2;
            value.EditExisShf = value.STOR_LEVEL_3;
            value.EditExisBin = value.STOR_LEVEL_4;
            if (value.DELETE_STORLOC_FLG == "FALSE") {
                value.ManualEdit = false;
                value.DELETE_STORLOC_FLG = false;
            }
            else {
                value.ManualEdit = true;
                value.DELETE_STORLOC_FLG = true;
            }
        });
        this.setState({ MatGridArray: LocGridData, pageNo: 1, pageCount: parseFloat(LocGridData.length) / 10, IsSearchResult: true });
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
    }
    BindGridData = () => {
        
        if (this.state.MatGridArray.length > 0) {
            return this.state.MatGridArray.map((value, index) => {
                if (index < parseInt(this.state.pageNo) * 10 && index >= parseInt(this.state.pageNo - 1) * 10) {
                    return (<React.Fragment key={index}>{value.IsEditClicked == false ? <>
                        <tr>

                            <td>{value.STOR_LEVEL_1}</td>
                            <td>{value.STOR_LEVEL_2}</td>
                            <td>{value.STOR_LEVEL_3}</td>
                            <td>{value.STOR_LEVEL_4}</td>
                            <td>BIN</td>
                            <td>
                                <div className="custom-control custom-checkbox item-custom-control">
                                    <input type="checkbox" className="custom-control-input" id="Activechk" disabled={true} name="Activechk" checked={value.ManualEdit} />
                                    <label className="custom-control-label pt-1" htmlFor="Activechk"></label>
                                </div>
                            </td>
                            <td data-label="BIN">
                                <td className="text-center px-0" style={{ "borderBottom": "0px solid" }}><span onClick={(e) => this.onEditClick(e, index)}><img className="px-1" src="Images/edit-icon.png" alt="Edit" title="Edit" style={{ height: '17px' }} /></span></td>
                            </td>
                        </tr>
                    </> : <>
                            <tr>
                                <td >
                                    <input type="text" className="form-control" maxLength="4" placeholder="Enter Value" name="EditExisAis" value={value.EditExisAis} onChange={e => this.OnHandleExisChange(e, "EditExisAis", index)} />
                                </td>
                                <td >
                                    <input type="text" className="form-control" maxLength="4" placeholder="Enter Value" name="EditExisRow" value={value.EditExisRow} onChange={e => this.OnHandleExisChange(e, "EditExisRow", index)} />
                                </td>
                                <td >
                                    <input type="text" className="form-control" maxLength="4" placeholder="Enter Value" name="EditExisShf" value={value.EditExisShf} onChange={e => this.OnHandleExisChange(e, "EditExisShf", index)} />
                                </td>
                                <td >
                                    <input type="text" className="form-control" maxLength="4" placeholder="Enter Value" name="EditExisBin" value={value.EditExisBin} onChange={e => this.OnHandleExisChange(e, "EditExisBin", index)} />
                                </td>
                                <td>BIN</td>
                                <td>
                                    <div className="custom-control custom-checkbox item-custom-control">
                                        <input type="checkbox" className="custom-control-input" id={'Activechk' + index} name="Activechk" checked={value.ManualEdit} onChange={e => this.OnHandleExisChange(e, "DELETE_STORLOC_FLG", index)} />
                                        <label className="custom-control-label pt-1" htmlFor={'Activechk' + index}></label>
                                    </div>
                                </td>
                                <td data-label="BIN">
                                    <td className="text-center px-0" style={{ "borderBottom": "0px solid" }}><span onClick={(e) => this.UpdateClick(e, index)}><img className="px-1" src="Images/tick.png" alt="Save" title="Save" style={{ "height": '17px', "borderBottom": "0px solid" }} /></span><span onClick={(e) => this.onCancelClick(e, index)}><img src="Images/cancel-icon.svg" alt="Cancel" title="Cancel" style={{ "height": '17px', "borderBottom": "0px solid" }} /></span></td>
                                </td>
                            </tr>
                        </>}
                    </React.Fragment>

                    );
                }

            })

        }
    }
    OnHandleNewChange = (e, type) => {
        
        if (type == "DELETE_STORLOC_FLGChk") {
            this.setState({ [e.target.name]: e.target.checked });
        }
        else {
            this.setState({ [e.target.name]: e.target.value });
        }
    };
    OnHandleExisChange = (e, type, index) => {
        
        let { MatGridArray } = this.state;
        if (type == "EditExisAis") {
            this.state.MatGridArray[index].EditExisAis = e.target.value;
        }
        else if (type == "EditExisRow") {
            this.state.MatGridArray[index].EditExisRow = e.target.value;
        }
        else if (type == "EditExisShf") {
            this.state.MatGridArray[index].EditExisShf = e.target.value;
        }
        else if (type == "EditExisBin") {
            this.state.MatGridArray[index].EditExisBin = e.target.value;
        }
        else if (type == "DELETE_STORLOC_FLG") {
            this.state.MatGridArray[index].ManualEdit = e.target.checked;
            //CPW-275[ WW_1040_PC_06 Spaces can be inserted in Material Storage Location] -Nandhini L
            if (this.state.MatGridArray[index].ManualEdit == true) {
                this.state.MatGridArray[index].DELETE_STORLOC_FLG = true;
            }
            else {
                this.state.MatGridArray[index].DELETE_STORLOC_FLG = false;

            }
            //this.state.MatGridArray[index].DELETE_STORLOC_FLG = e.target.checked;
        }
        this.setState({ MatGridArray: MatGridArray });
    };
    onEditClick = (e, index) => {
        let { MatGridArray } = this.state;
        //CPW-275[ WW_1040_PC_04 Spaces can be inserted in Material Storage Location] -Nandhini L
        if (existIndex != -1) {
            //this.onCancelClick(e, existIndex)
            this.state.MatGridArray[existIndex].IsEditClicked = false;
        }
        this.state.MatGridArray[index].IsEditClicked = true;
        existIndex = index;
        this.setState({ MatGridArray: MatGridArray, IsNewLoc: false })
    };
    onCancelClick = (e, index) => {
        
        let { MatGridArray } = this.state;
        //bug - 2573 - Material storage location - without performing any action, active status was changing automatically - Dhamotharan P
        //CPW-275[ WW_1040_PC_07 Spaces can be inserted in Material Storage Location] -Nandhini L
        if (this.state.iseditClick == true) {
            this.state.MatGridArray[index].ManualEdit = this.state.MatGridArray[index].DELETE_STORLOC_FLG;
        }
        else {
            this.state.MatGridArray[index].ManualEdit = !this.state.MatGridArray[index].DELETE_STORLOC_FLG;
        }
        this.state.MatGridArray[index].EditExisAis = this.state.MatGridArray[index].STOR_LEVEL_1;
        this.state.MatGridArray[index].EditExisRow = this.state.MatGridArray[index].STOR_LEVEL_2;
        this.state.MatGridArray[index].EditExisShf = this.state.MatGridArray[index].STOR_LEVEL_3;
        this.state.MatGridArray[index].EditExisBin = this.state.MatGridArray[index].STOR_LEVEL_4;
        //2231 Material Storage Location_ Active status is displayed in the panel though the location is not activated - Deepthi
        //if (this.state.MatGridArray[index].ManualEdit == true) {
        //    let IsActive = this.state.MatGridArray[index].DELETE_STORLOC_FLG;
        //    if (IsActive) {
        //        MatGridArray[index].DELETE_STORLOC_FLG = false;
        //    }
        //    else {
        //        MatGridArray[index].DELETE_STORLOC_FLG = true;
        //    }

        //}



        this.state.MatGridArray[index].IsEditClicked = false;
        this.setState({ MatGridArray: MatGridArray, iseditClick: false })
    };
    onNewCancelClick = (e) => {
        this.setState({ IsNewLoc: false });
    };
    onNewLocClick = (e) => {
        if (this.state.IsNewLoc == false) {
            let { MatGridArray } = this.state;
            MatGridArray.map((val, index) => {
                val.IsEditClicked = false;

            });
            this.setState({ MatGridArray: MatGridArray, IsNewLoc: true, NewLocAis: "", NewLocBin: "", NewLocShf: "", NewLocRow: "" });
        }
    };
    UpdateClick = (e, index) => {
        let { MatGridArray } = this.state;
        //CPW-275[ WW_1040_PC_01 Spaces can be inserted in Material Storage Location] -Nandhini L
        let newAisle = MatGridArray[index].EditExisAis.trim()
        let newRow = MatGridArray[index].EditExisRow.trim()
        let newShelf = MatGridArray[index].EditExisShf.trim()
        let newBin = MatGridArray[index].EditExisBin.trim()
        let existAisle = MatGridArray[index].STOR_LEVEL_1.trim()
        let existRow = MatGridArray[index].STOR_LEVEL_2.trim()
        let existShelf = MatGridArray[index].STOR_LEVEL_3.trim()
        let existBin = MatGridArray[index].STOR_LEVEL_4.trim()
        this.setState({ EditIndex: index });
        if (newAisle == "" && newRow == "" && newShelf == "" && newBin == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter Aisle, Row, Shelf and Bin'
            });
            // alert('Please Enter Aisle, Row, Shelf and Bin');
        }
        else if (newAisle == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter Aisle'
            });
            // alert('Please Enter Row');
        }
        else if (newRow == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter Row'
            });
            //    alert('Please Enter Shelf');
        }
        else if (newShelf == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter Shelf'
            });
            // alert('Please Enter Bin');
        }
        else if (newBin == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please enter Bin'
            });
            // alert('Please Enter Bin');
        }
        //else {
        //    $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        //    if (newRow == existRow && newAisle == existAisle && newShelf == existShelf && newBin == existBin) {
        //        swal({
        //            allowOutsideClick: false,
        //            closeOnClickOutside: false,
        //            text: 'Successfully updated material storage location'
        //        });
        //        this.state.MatGridArray[index].IsEditClicked = false;
        //        $(`#${SDIConstants.SDILoader}`).addClass('hide');

        //        let { MatGridArray } = this.state;

        //        MatGridArray.map((val, index) => {
        //            if (index == this.state.EditIndex) {
        //                val.DELETE_STORLOC_FLG = this.state.MatGridArray[index].ManualEdit
        //                val.STOR_LEVEL_1 = this.state.MatGridArray[index].EditExisAis.trim()
        //                val.STOR_LEVEL_2 = this.state.MatGridArray[index].EditExisRow.trim()
        //                val.STOR_LEVEL_3 = this.state.MatGridArray[index].EditExisShf.trim()
        //                val.STOR_LEVEL_4 = this.state.MatGridArray[index].EditExisBin.trim()
        //                val.IsEditClicked = false;

        //            }
        //        });
        //        this.setState({ MatGridArray: MatGridArray })
        //        this.setState({ NewLocBin: "", NewLocShf: "", NewLocRow: "", NewLocAis: "", DELETE_STORLOC_FLGChk: false, iseditClick: true });

        //    }

            else {
                let AddOrUpdateLocationBO = {
                    Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
                    Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                    SelectedBU: this.state.BuDDValue,
                    SelectedArea: this.state.SelectedArea.value,
                    IsNewLoc: this.state.IsNewLoc,
                    SelectedAisle: newAisle,
                    SelectedRow: newRow,
                    SelectedShelf: newShelf,
                    SelectedBin: newBin,
                    SelectedOldAisle: existAisle,
                    SelectedOldRow: existRow,
                    SelectedOldShelf: existShelf,
                    SelectedOldBin: existBin,
                    DELETE_STORLOC_FLG: MatGridArray[index].ManualEdit ? "N" : "Y",
                    Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID")
                }
                MaterialStorageLocAction.AddOrUpdateLoc(AddOrUpdateLocationBO);
            }
        //}

    };

    InsertClick = (e) => {
        //WW-795 User is able to select "empty" option on Default Putaway Locations page Pavithra R[9/5/2023]
        if (this.state.NewLocAis.trim() == "" && this.state.NewLocRow.trim() == "" && this.state.NewLocShf.trim() == "" && this.state.NewLocBin.trim() == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please Enter Aisle, Row, Shelf and Bin'
            });
            // alert('Please Enter Aisle, Row, Shelf and Bin');
        }
        else if (this.state.NewLocAis.trim() == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please Enter Aisle'
            });
            // alert('Please Enter Row');
        }
        else if (this.state.NewLocRow.trim() == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please Enter Row'
            });
            //  alert('Please Enter Row');
        }
        else if (this.state.NewLocShf.trim() == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please Enter Shelf'
            });
            // alert('Please Enter Shelf');
        }
        else if (this.state.NewLocBin.trim() == "") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: 'Please Enter Bin'
            });
            //alert('Please Enter Bin');
        }
        else {
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            let AddOrUpdateLocationBO = {
                Session_UserID: CookieService.getLocalStorageValues("Session_UserID"),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                SelectedBU: this.state.BuDDValue,
                SelectedArea: this.state.SelectedArea.value,
                IsNewLoc: this.state.IsNewLoc,
                SelectedAisle: this.state.NewLocAis,
                SelectedRow: this.state.NewLocRow,
                SelectedShelf: this.state.NewLocShf,
                SelectedBin: this.state.NewLocBin,
                SelectedOldAisle: "",
                SelectedOldRow: "",
                SelectedOldShelf: "",
                SelectedOldBin: "",
                DELETE_STORLOC_FLG: this.state.DELETE_STORLOC_FLGChk ? "N" : "Y",
                Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID")
            }
            MaterialStorageLocAction.AddOrUpdateLoc(AddOrUpdateLocationBO);
        }

    };
    EditClickResponse = () => {
        
        let AddOrUpdateLocData = JSON.parse(MaterialStorageLocStore.AddOrUpdateLoc);
        if (this.state.EditIndex == "") {
            this.setState({ IsNewLoc: false });
        }
        //CPW-275[ WW_1040_PC_08 Spaces can be inserted in Material Storage Location] -Nandhini L
        if (AddOrUpdateLocData == "Successfully updated material storage location") {
            let { MatGridArray } = this.state;
            this.state.MatGridArray[this.state.EditIndex].IsEditClicked = false;


            MatGridArray.map((val, index) => {
                if (index == this.state.EditIndex) {
                    val.DELETE_STORLOC_FLG = this.state.MatGridArray[index].ManualEdit
                    val.STOR_LEVEL_1 = this.state.MatGridArray[index].EditExisAis.trim()
                    val.STOR_LEVEL_2 = this.state.MatGridArray[index].EditExisRow.trim()
                    val.STOR_LEVEL_3 = this.state.MatGridArray[index].EditExisShf.trim()
                    val.STOR_LEVEL_4 = this.state.MatGridArray[index].EditExisBin.trim()
                    val.IsEditClicked = false;

                }
            });


            this.setState({ MatGridArray: MatGridArray })
            this.setState({ AddOrUpdateLocRes: AddOrUpdateLocData, NewLocBin: "", NewLocShf: "", NewLocRow: "", NewLocAis: "", DELETE_STORLOC_FLGChk: false });
            // this.BindGridData();
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: AddOrUpdateLocData
            });
            //  alert(AddOrUpdateLocData);
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
        else if (AddOrUpdateLocData == "Successfully added new material storage location") {
            this.setState({ AddOrUpdateLocRes: AddOrUpdateLocData, NewLocBin: "", NewLocShf: "", NewLocRow: "", NewLocAis: "", DELETE_STORLOC_FLGChk: false });

            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: AddOrUpdateLocData
            });
            this.SearchBtnClick();
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: AddOrUpdateLocData
            });
            //  alert(AddOrUpdateLocData);
            $(`#${SDIConstants.SDILoader}`).addClass('hide');
        }
    };
    handlePageClick = (e) => {
        let pageNo = e.selected + 1;
        this.setState({ pageNo: pageNo });
    }
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Material Storage Locations",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            MaterialStorageLocAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            MaterialStorageLocAction.deleteFavPage(deleteFavPageBO)
        }
    };
    loadFavPageResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let favPageResponse = JSON.parse(MaterialStorageLocStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        if (MaterialStorageLocStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(MaterialStorageLocStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(MaterialStorageLocStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        // this.refreshMenu();
    };
    //WW-323 Material Storage Location - Add Sorting - Deepthi
    SortClick = (event, sortBy, columnName) => {
        
        let MatGrid = this.state.MatGridArray;
        //MatGrid = MatGrid.map(name => name.toLowerCase())
        console.log("MatGrid", MatGrid)
        if (sortBy == "ASC") {
            //WW -323_PC__01 sorting issue -Aparna
            switch (columnName) {
                case "STOR_LEVEL_1": {
                    MatGrid.sort(function (a, b) {
                        var textA = a.STOR_LEVEL_1.toUpperCase();
                        var textB = b.STOR_LEVEL_1.toUpperCase();
                        return (textA > textB) ? 1 : -1;
                    });
                    break;
                }
                case "STOR_LEVEL_2": {
                    MatGrid.sort(function (a, b) {
                        var textA = a.STOR_LEVEL_2.toUpperCase();
                        var textB = b.STOR_LEVEL_2.toUpperCase();
                        return (textA > textB) ? 1 : -1;
                    });
                    break;
                }
                case "STOR_LEVEL_3": {
                    MatGrid.sort(function (a, b) {
                        var textA = a.STOR_LEVEL_3.toUpperCase();
                        var textB = b.STOR_LEVEL_3.toUpperCase();
                        return (textA > textB) ? 1 : -1;
                    });
                    break;
                }
                case "STOR_LEVEL_4": {
                    MatGrid.sort(function (a, b) {
                        var textA = a.STOR_LEVEL_4.toUpperCase();
                        var textB = b.STOR_LEVEL_4.toUpperCase();
                        return (textA > textB) ? 1 : -1;
                    });
                    break;
                }
            }
            // MatGrid.sort((a, b) => a.columnName > b.columnName ? 1 : -1);
        }
        else {
            switch (columnName) {
                case "STOR_LEVEL_1": {
                    MatGrid.sort(function (a, b) {
                        var textA = a.STOR_LEVEL_1.toUpperCase();
                        var textB = b.STOR_LEVEL_1.toUpperCase();
                        return (textA > textB) ? -1 : 1;
                    });
                    break;
                }
                case "STOR_LEVEL_2": {
                    // MatGrid.sort((a, b) => a.STOR_LEVEL_2 > b.STOR_LEVEL_2 ? -1 : 1)
                    MatGrid.sort(function (a, b) {
                        var textA = a.STOR_LEVEL_2.toUpperCase();
                        var textB = b.STOR_LEVEL_2.toUpperCase();
                        return (textA > textB) ? -1 : 1;
                    });
                    break;
                }
                case "STOR_LEVEL_3": {
                    MatGrid.sort(function (a, b) {
                        var textA = a.STOR_LEVEL_3.toUpperCase();
                        var textB = b.STOR_LEVEL_3.toUpperCase();
                        return (textA > textB) ? -1 : 1;
                    });
                    break;
                }
                case "STOR_LEVEL_4": {
                    MatGrid.sort(function (a, b) {
                        var textA = a.STOR_LEVEL_4.toUpperCase();
                        var textB = b.STOR_LEVEL_4.toUpperCase();
                        return (textA > textB) ? -1 : 1;
                    });
                    break;
                }
            }
            // MatGrid.sort((a, b) => a.columnName > b.columnName ? -1 : 1);
        }
        this.setState({ MatGridArray: MatGrid });
    };
    render() {
        return (
            //<div className="container-fluid content-section">
            <div className="container-fluid container-margin content-section" >
                <div className="row">

                    <div className="col-md-12 page-heading mb-3">
                        <h5 className="page-title">Material Storage Locations</h5>
                        <div className="fav-item-maintenance-icon mt-1">
                            <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                            <label htmlFor="checkbox-OrdStatus">
                                <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                    <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                        <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                        <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                        <g className="grp7" opacity={0} transform="translate(7 6)">
                                            <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                            <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                        </g>
                                        <g className="grp6" opacity={0} transform="translate(0 28)">
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                        </g>
                                        <g className="grp3" opacity={0} transform="translate(52 28)">
                                            <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                            <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                        </g>
                                        <g className="grp2" opacity={0} transform="translate(44 6)">
                                            <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                            <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp5" opacity={0} transform="translate(14 50)">
                                            <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp4" opacity={0} transform="translate(35 50)">
                                            <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                            <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                        </g>
                                        <g className="grp1" opacity={0} transform="translate(24)">
                                            <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                            <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                        </g>
                                    </g>
                                </svg>
                            </label>
                        </div>
                    </div>
                    <div className="col-md-12 mb-3">
                        <div className="row ">


                            <div className="col-md-4 mb-3">
                                <label className="catalog-label mt-2 mr-3"><span>Crib</span></label>
                                <span style={{ "fontSize": "12px" }}><Select
                                    id="cribid"
                                    name="cribDD"
                                    style={{ "width": "80px" }}
                                    onChange={(e) => this.OnChangeBU(e)}
                                    value={this.state.BuDDName ? { label: this.state.BuDDName } : null}
                                    options={this.state.BuOptions}
                                    placeholder="Select"
                                /></span>
                            </div>
                            <div className="col-md-4 mb-3" >
                                <label className="catalog-label mt-2 mr-3">Area</label>
                                <span style={{ "fontSize": "12px" }}><Select
                                    id="areaid"
                                    name="areaDD"
                                    placeholder="Select"
                                    options={this.state.Area}
                                    value={Object.keys(this.state.SelectedArea).length > 0 ? this.state.SelectedArea : null}
                                    onChange={(e) => this.OnChangeArea(e)}
                                /></span>
                            </div>
                            <div class="col-md-4 align-items-end d-flex mb-3">
                                <button class="btn btn-primary custom-btn-primary primary-btn px-3 materialSearch_btn" onClick={() => this.SearchBtnClick()} ><Trans>Search</Trans></button>
                            </div>
                            {/*  <span className="float-left" style={{ "marginLeft": "3%" }}>
                                                <button className="btn btn-primary custom-btn-primary primary-btn px-3" onClick={() => this.SearchBtnClick()}  ><Trans>Search</Trans></button>
                                            </span> */}




                            {/*Item Info starts here*/}
                            {/*[9/20/22, Bug - 2677 - To show add new material storage location button and grid, Dhevanesm R]*/}
                            {this.state.IsSearchResult == true ? < div class="col-md-12 float-left mb-4">
                                <div class="table-responsive table-customstyle-whitespace mt-3" style={{ "marginBottom": "10%", "overflow": "hidden" }}>

                                    <div className="row" style={{
                                        float: "right",
                                        marginRight: "0.1%"
                                    }}>
                                        {/* <tr>
                                                <td><a href="#">Add New Material Storage Location</a></td>
                                            </tr>*/}
                                        <span className="float-left">
                                            {/*<a href="#" target="" onClick={(e) => this.onNewLocClick(e)}>Add New Material Storage Location</a>*/}
                                            <button style={{ "float": "right" }} className="btn btn-primary custom-btn-primary primary-btn px-3" style={{ "marginBottom": "8%" }} onClick={(e) => this.onNewLocClick(e)} >Add New Material Storage Location</button>
                                        </span>
                                    </div>
                                    <table class="table ZEUS_Grid FOM-grid mobileflex-grid" id="table">
                                        <thead>
                                            <tr>
                                                <th className="d-sm-none d-md-table-cell position-sort-icon">Aisle <span className="sort-up ml-1" style={{ "top": "7px" }}><img src="Images/sort2.svg" onClick={(e) => this.SortClick(e, "ASC", "STOR_LEVEL_1")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={(e) => this.SortClick(e, "DESC", "STOR_LEVEL_1")} /></span></th>
                                                <th className="d-sm-none d-md-table-cell position-sort-icon">Row <span className="sort-up ml-1" style={{ "top": "7px" }}><img src="Images/sort2.svg" onClick={(e) => this.SortClick(e, "ASC", "STOR_LEVEL_2")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={(e) => this.SortClick(e, "DESC", "STOR_LEVEL_2")} /></span></th>
                                                <th className="d-sm-none d-md-table-cell position-sort-icon">Shelf <span className="sort-up ml-1" style={{ "top": "7px" }}><img src="Images/sort2.svg" onClick={(e) => this.SortClick(e, "ASC", "STOR_LEVEL_3")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={(e) => this.SortClick(e, "DESC", "STOR_LEVEL_3")} /></span></th>
                                                <th className="d-sm-none d-md-table-cell position-sort-icon">Bin <span className="sort-up ml-1" style={{ "top": "7px" }}><img src="Images/sort2.svg" onClick={(e) => this.SortClick(e, "ASC", "STOR_LEVEL_4")} /></span><span className="sort-down ml-1"><img src="Images/sort1.svg" onClick={(e) => this.SortClick(e, "DESC", "STOR_LEVEL_4")} /></span></th>
                                                <th>Location type</th>
                                                <th>Active</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.IsNewLoc ? <tr>

                                                <td >
                                                    <input type="text" className="form-control" maxLength="4" placeholder="Enter value" name="NewLocAis" value={this.state.NewLocAis} onChange={e => this.OnHandleNewChange(e, "1")} />
                                                </td>
                                                <td >
                                                    <input type="text" className="form-control" maxLength="4" placeholder="Enter value" name="NewLocRow" value={this.state.NewLocRow} onChange={e => this.OnHandleNewChange(e, "2")} />
                                                </td>
                                                <td >
                                                    <input type="text" className="form-control" maxLength="4" placeholder="Enter value" name="NewLocShf" value={this.state.NewLocShf} onChange={e => this.OnHandleNewChange(e, "3")} />
                                                </td>
                                                <td >
                                                    <input type="text" className="form-control" maxLength="4" placeholder="Enter value" name="NewLocBin" value={this.state.NewLocBin} onChange={e => this.OnHandleNewChange(e, "4")} />
                                                </td>
                                                <td>BIN</td>
                                                <td>
                                                    <div className="custom-control custom-checkbox item-custom-control">
                                                        <input type="checkbox" className="custom-control-input" id="NewActivechk" name="DELETE_STORLOC_FLGChk" checked={this.state.DELETE_STORLOC_FLGChk} onChange={e => this.OnHandleNewChange(e, "DELETE_STORLOC_FLGChk")} />
                                                        <label className="custom-control-label pt-1" htmlFor="NewActivechk"></label>
                                                    </div>
                                                </td>
                                                <td data-label="BIN">
                                                    <td className="text-center px-0" style={{ "borderBottom": "0px solid" }}><span onClick={(e) => this.InsertClick(e)}><img className="px-1" src="Images/tick.png" alt="Save" title="Save" style={{ height: '17px' }} /></span><span onClick={(e) => this.onNewCancelClick(e)}><img src="Images/cancel-icon.svg" alt="Cancel" title="Cancel" style={{ height: '17px' }} /></span></td>
                                                </td>
                                            </tr> : null}
                                            {this.state.MatGridArray.length > 0 ? this.BindGridData() : null}
                                        </tbody>
                                    </table>
                                    {this.state.MatGridArray.length > 0 ?
                                        <div className="col-md-12 ">
                                            <span className="total-records mt-2 d-inline-block">
                                                <Trans>Number of Records</Trans><span> :</span><span className="ml-2">{this.state.MatGridArray.length}</span>
                                            </span>
                                            {this.state.MatGridArray.length > 10 ? <ReactPaginate
                                                previousLabel={<span className="right-pagination-arrow" />}
                                                nextLabel={<span className="left-pagination-arrow" />}
                                                previousClassName={'page-item'}
                                                nextClassName={'page-item'}
                                                previousLinkClassName={'page-link'}
                                                nextLinkClassName={'page-link'}
                                                disabledClassName={'disabled'}
                                                breakLabel={'...'}
                                                breakClassName={'page-item'}
                                                breakLinkClassName={'page-link'}
                                                pageCount={this.state.pageCount}
                                                marginPagesDisplayed={1}
                                                pageRangeDisplayed={2}
                                                onPageChange={this.handlePageClick}
                                                containerClassName={'custom-pagination pagination float-right'}
                                                pageClassName={'page-item'}
                                                pageLinkClassName={'page-link'}
                                                activeClassName={'active'}
                                                hrefBuilder={() => '#'}
                                                forcePage={this.state.pageNo - 1}
                                            /> : null}

                                        </div> : <section className="site-undercontruction container text-center center-panel pt-4">
                                            <div className="img-section">
                                                <img src="images/nosearch.jpg" alt="imagefile" />
                                            </div>
                                            <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                                            </p>
                                        </section>}
                                </div>
                            </div> : null}
                            {/*[9/20/22, Bug - 2677 - To hide no records found, Dhevanesm R]*/}
                            {/* {this.state.IsSearchResult == true ? <section className="site-undercontruction container text-center center-panel pt-4">
                                    <div className="img-section">
                                        <img src="images/nosearch.jpg" alt="imagefile" />
                                    </div>
                                    <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                                    </p>
                                </section>:null}*/}
                            {/*Item Info ends here*/}

                        </div>
                    </div>
                </div>
            </div>


        );
    };
}
export default withTranslation()(MaterialStorageLocComponent);